import styled from "styled-components";

export const PageLoaderStyles = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: var(--272727, #272727);
  display: flex;
  justify-content: center;
  align-items: center;
`;
